module.exports = __webpack_public_path__ + "img/dh.b8653aec.png";